import { useCmsNavigationContext } from 'contexts/CmsNavigationContext';

import { CmsMenu } from './CmsMenu';

export const CmsLeftMenu = () => {
  const { links } = useCmsNavigationContext();

  return <CmsMenu links={links} />;
};
